export class SetProjectRoleError {
  public static readonly type = '[Authorisation] SetProjectRoleError';
  constructor(public readonly error: Error) {}
}
